import type { Nullable } from '@clearverify/types';

import type { EmployerQuery } from 'src/api';
import type { SelectFieldOption } from 'src/types/components';

export enum EmployerCompanyInformationFormFields {
  displayName = 'displayName',
  industry = 'industry',
  corporateStructure = 'corporateStructure',
  numberOfEmployees = 'numberOfEmployees',
  contactEmail = 'contactEmail',
  contactPhoneNumber = 'contactPhoneNumber',
  taxYearEndDate = 'taxYearEndDate',
  headquarters = 'headquarters',
  disclaimer = 'disclaimer',
}

export type EmployerCompanyInformationFormValues = {
  [EmployerCompanyInformationFormFields.displayName]: Nullable<string>;
  [EmployerCompanyInformationFormFields.industry]: Nullable<SelectFieldOption>;
  [EmployerCompanyInformationFormFields.taxYearEndDate]: Nullable<string>;
  [EmployerCompanyInformationFormFields.corporateStructure]: Nullable<string>;
  [EmployerCompanyInformationFormFields.numberOfEmployees]: Nullable<number>;
  [EmployerCompanyInformationFormFields.contactEmail]: Nullable<string>;
  [EmployerCompanyInformationFormFields.contactPhoneNumber]: Nullable<string>;
  [EmployerCompanyInformationFormFields.disclaimer]: Nullable<string>;
  [EmployerCompanyInformationFormFields.headquarters]: NonNullable<
    EmployerQuery['employer']
  >['headquarters'];
};
